/**
 * 二维码显示组件 支持中文
 */
<template>
  <div class="qrcode-container">
    <img id="image"></img>
  </div>
</template>

<script>
import QRCode from 'qrcode';

export default {
  name: 'QrCode',
  props: {
    // 二维码内容
    text: {
      type: String,
      required: true
    },
    // 二维码宽度
    width: {
      type: Number,
      default: 200
    },
    // 内边距
    margin: {
      type: Number,
      default: 0
    },
    // 错误更正级别 L（低）~7%, M（中）~15%, Q（四分位数）~25%, H（高）~30%
    errorCorrectionLevel: {
      type: String,
      default: 'M'
    },
    // 深色部分颜色
    colorDark: {
      type: String,
      default: '#000000'
    },
    // 浅色部分颜色
    colorLight: {
      type: String,
      default: '#ffffff'
    }
  },
  watch: {
    // 监听内容变化，动态更新二维码
    text(newVal) {
      this.generateQrCode(newVal);
    }
  },
  mounted() {
    // 初始化生成二维码
    this.generateQrCode(this.text);
  },
  methods: {
    // 生成二维码
    generateQrCode(text) {
      const options = {
        width: this.width,
        errorCorrectionLevel: this.errorCorrectionLevel,
        type: 'image/jpeg',
        quality: 0.3,
        margin: this.margin,
        color: {
          dark: this.colorDark,
          light: this.colorLight
        }
      };
      QRCode.toDataURL(text, options, function(err, url) {
        if (err) throw err;
        const img = document.getElementById('image');
        img.src = url;
      });
    }
  }
};
</script>

<style scoped>
.qrcode-container {
  display: inline-block;
  background-color: #ffffff;
  border-radius: 8px;
}
</style>
